import React from "react";

const AboutUs = () => {
    return (
        <>
            This is AboutUs Page
        </>
    );
};

export default AboutUs;
